import { Link } from "react-router-dom";
import { ArrowRight, ShieldCheck, Clock, FileCheck, UserCheck, Globe, AlertTriangle } from "lucide-react";

const REQUIREMENTS = [
  { icon: FileCheck, label: "Explicit consent" },
  { icon: FileCheck, label: "Privacy notices" },
  { icon: UserCheck, label: "A named Data Protection Officer" },
  { icon: Clock, label: "Respond to individuals within 45 days" },
  { icon: Globe, label: "Controls on transfers abroad" },
  { icon: AlertTriangle, label: "Breach notification within 72 hours" },
];

export function Compliance() {
  return (
    <section data-testid="compliance-section" className="relative overflow-hidden bg-wafa-deep text-white grain-overlay">
      <div className="mx-auto grid max-w-7xl gap-12 px-4 py-20 lg:grid-cols-12 lg:gap-16 lg:px-6 lg:py-28">
        <div className="lg:col-span-6">
          <div className="text-xs font-semibold uppercase tracking-widest text-wafa-sunshine">Compliance</div>
          <h2 className="mt-3 font-heading text-3xl font-semibold tracking-tight text-white sm:text-4xl lg:text-5xl">
            Oman's data protection law is enforced. Most companies are not ready.
          </h2>
          <div className="mt-6 space-y-4 text-sm leading-relaxed text-white/80 lg:text-base">
            <p>
              Royal Decree 6/2022 sets out the Personal Data Protection Law. Executive Regulations
              were issued under Ministerial Decision 34/2024, and the law is fully enforceable from
              5 February 2026, supervised by the Ministry of Transport, Communications and
              Information Technology (MTCIT).
            </p>
            <p>
              We build these requirements into the product from the first sprint, and we treat
              where data sits as a decision the client makes deliberately — never a shortcut.
            </p>
          </div>

          <div className="mt-8 flex flex-wrap items-center gap-3">
            <Link
              to="/meyar"
              data-testid="compliance-cta-meyar"
              className="inline-flex items-center gap-2 rounded-md bg-white px-5 py-3 text-sm font-semibold text-wafa-deep transition-colors duration-200 hover:bg-wafa-sunshine"
            >
              Explore Meyar
              <ArrowRight className="h-4 w-4" />
            </Link>
            <Link
              to="/tools/pdpl-readiness-check"
              data-testid="compliance-cta-tool"
              className="inline-flex items-center gap-2 rounded-md border border-white/30 px-5 py-3 text-sm font-semibold text-white transition-colors duration-200 hover:border-white hover:bg-white/5"
            >
              Take the PDPL Readiness Check
            </Link>
          </div>
        </div>

        <div className="lg:col-span-6">
          <div className="rounded-xl border border-white/15 bg-white/5 p-6 backdrop-blur-sm">
            <div className="flex items-center gap-3">
              <div className="flex h-10 w-10 items-center justify-center rounded-md bg-wafa-primary text-white">
                <ShieldCheck className="h-5 w-5" />
              </div>
              <div className="font-heading text-lg font-semibold">What the law requires</div>
            </div>
            <ul className="mt-6 space-y-3">
              {REQUIREMENTS.map(({ icon: Icon, label }) => (
                <li key={label} className="flex items-center gap-3">
                  <Icon className="h-4 w-4 shrink-0 text-wafa-primary" />
                  <span className="text-sm text-white/90">{label}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
